import React from 'react';
import {get as _get} from 'lodash';

import {THIRD_PARTY_CLIENT_TUNNEL} from '@constants/resources';
import {IconInfoCircle} from '@appComponents/IconCollection';
import ClientOutputClientReferenceTable
    from '@modules/client/forms/ClientPackageTunnels/OutputClientReferences/ClientOutputClientReferenceTable';
import {TUNNEL_AUTOASSIGMENT_INFO} from '@modules/client/constants/tooltipMessages';
import Form from '@appComponents/ReduxFormControls';
import { BASE_FORM_MESSAGES, FORM_ERROR } from '@constants/messages';

import validate from './validatorThirdPartyClientTunnel';
import {
    GetThirdPartyTunnelsDropdownData,
    GetThirdPartyClientTunnel,
} from '../../../../graphql/thirdPartyClientTunnel/query.graphql';
import {
    CreateThirdPartyClientTunnel,
    DeleteThirdPartyClientTunnel,
    UpdateThirdPartyClientTunnel,
} from '../../../../graphql/thirdPartyClientTunnel/mutation.graphql';

const displayOutputClientReferenceTable = (data, variables, formData) => {
    return (
        <ClientOutputClientReferenceTable props={data} variables={variables} formData={formData}/>
    );
};
const ThirdPartyClientTunnelsModel = (formData, variables, formParams) => {
    return {
        deleteId: 'thirdPartyClientTunnel.id',
        entityDataMapKey: 'thirdPartyClientTunnel',
        entityLabel: 'Tunnel',
        formName: 'thirdPartyClientTunnel',
        resources: THIRD_PARTY_CLIENT_TUNNEL,
        showChangeLog: true,
        usePopupMessages: true,
        validate: validate,
        title: (data) =>  {
            const name = _get(data, 'thirdPartyClientTunnel.name', null);

            return name ? `Tunnel "${name}"` : '';
        },
        dataMap: {
            thirdPartyClientTunnel: {
                id: '',
                name: '',
                description: '',
                is_placeholder_for_auto_assignment: false,
                vtd_tunnel_id: {
                    id: '',
                },
                encoding_job_profile: {
                    id: '',
                },
                client_tp_tunnels: [],
            },
        },
        messages: {
            boxName: {
                delete: 'clientMessage',
                error: 'formInnerErrorMessage',
                success: 'clientMessage',
            },
            text: {
                ...BASE_FORM_MESSAGES,
                FORM_ERROR: () => FORM_ERROR('VTD tunnel'),
            },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'thirdPartyClientTunnel.id',
                props: {
                    label: '',
                    name: 'id',
                    hidden: true,
                },
            },
            name: {
                dataMapKey: 'thirdPartyClientTunnel.name',
                props: {
                    className: '--medium-width',
                    component: Form.SemanticInput,
                    label: 'Name',
                    name: 'name',
                    required: true,
                    type: 'input',
                },
            },
            description: {
                dataMapKey: 'thirdPartyClientTunnel.description',
                props: {
                    component: Form.SemanticInput,
                    label: 'Description',
                    name: 'description',
                    required: false,
                    type: 'input',
                },
            },
            is_placeholder_for_auto_assignment: {
                dataMapKey: 'thirdPartyClientTunnel.is_placeholder_for_auto_assignment',
                props: {
                    component: Form.SemanticInput,
                    type: 'toggle',
                    name: 'is_placeholder_for_auto_assignment',
                    label: 'Placeholder for auto-assignment',
                    description: <IconInfoCircle tooltip={TUNNEL_AUTOASSIGMENT_INFO()}/>,
                    defaultValue: true,
                },
            },
            vtd_tunnel_id: {
                dataMapKey: 'thirdPartyClientTunnel.vtd_tunnel_id',
                optionsKey: 'vtdTunnelsUnusedByClient',
                props: {
                    className: '--medium-width',
                    component: Form.SemanticSelect,
                    label: 'VTD tunnel',
                    name: 'vtd_tunnel_id',
                    required: true,
                    hidden: true,
                },
            },
            encoding_job_profile: {
                dataMapKey: 'thirdPartyClientTunnel.encoding_job_profile.id',
                optionsKey: 'encodingJobProfiles',
                props: {
                    className: '--medium-width',
                    component: Form.SemanticSelect,
                    label: 'Encoding job profile',
                    name: 'encoding_job_profile',
                    required: true,
                },
            },
            client_tp_tunnels: {

                props: {
                    component: (props) => displayOutputClientReferenceTable(props, variables, formParams),
                    name: 'client_tp_tunnels',
                    className: 'client_tp_tunnels --small-width',
                    hidden: true,
                },
            },
        },
        mutation: {
            createEntity: CreateThirdPartyClientTunnel,
            deleteEntity: DeleteThirdPartyClientTunnel,
            updateEntity: UpdateThirdPartyClientTunnel,
        },
        mutationOptions: {
            create: {
                refetchQueries: ['GetThirdPartyTunnelsForTable'],
            },
            update: {
                refetchQueries: ['GetThirdPartyTunnelsForTable'],
            },
            delete: {
                refetchQueries: ['GetThirdPartyTunnelsForTable'],
            },
        },
        query: {
            getOptions: GetThirdPartyTunnelsDropdownData,
            getEntity: GetThirdPartyClientTunnel,
        },
    };
};

export default ThirdPartyClientTunnelsModel;
